import React, { useState, useEffect } from 'react';
import './App.css';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { pdfjs } from 'react-pdf';

import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import Dashboard from './pages/Dashboard';
import PricingPage from './pages/PricingPage';
import LandingPage from './pages/LandingPage';
import FinancialsPage from './pages/FinancialsPage';
import BlueprintsPage from './pages/BlueprintsPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const isLanding = ['/', '/success', '/cancel'].includes(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  const handleSidebarBlueprintsClick = () => navigate('/blueprints');

  return (
    <Elements stripe={stripePromise}>
      <div className="app-container">
        {!isLanding && (
          <TopBar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        )}

        <div style={{ display: 'flex' }}>
          {!isLanding && (
            <Sidebar isOpen={sidebarOpen} onBlueprintsClick={handleSidebarBlueprintsClick} />
          )}
          <div className={`main-content ${!isLanding && sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects/:projectId/blueprints" element={<BlueprintsPage />} />
              <Route path="/blueprints" element={<BlueprintsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/financials" element={<FinancialsPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/cancel" element={<CancelPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </Elements>
  );
}

export default App;
